export var createNativeMediaRecorderConstructor = function (window) {
    if (window === null) {
        return null;
    }
    return window.MediaRecorder === undefined ? null : window.MediaRecorder;
};
//# sourceMappingURL=native-media-recorder-constructor.js.map
